import { mediaUrl } from "@/lib/api";

export const Logo = ({ className = "h-12 w-12", settings }) => {
  if (settings?.logo_url) {
    return <img src={mediaUrl(settings.logo_url)} alt="BJRC logo" className={`${className} rounded-full bg-white object-contain p-1`} />;
  }
  return (
    <svg className={className} viewBox="0 0 100 100" aria-label="BJRC logo">
      <circle cx="50" cy="50" r="48" fill="#fff" stroke="#0B2A4A" strokeWidth="3" />
      <circle cx="50" cy="50" r="40" fill="none" stroke="#1E63D6" strokeWidth="1.5" />
      <path d="M50 22 L52 50 L50 74 L48 50 Z" fill="#0A6B3B" />
      <g stroke="#0A6B3B" strokeWidth="2.4" strokeLinecap="round">
        <path d="M50 30 L41 36 M50 30 L59 36" />
        <path d="M50 40 L39 47 M50 40 L61 47" />
        <path d="M50 50 L40 57 M50 50 L60 57" />
        <path d="M50 60 L43 66 M50 60 L57 66" />
      </g>
      <text x="50" y="90" textAnchor="middle" fontFamily="Barlow Condensed, sans-serif" fontWeight="800" fontSize="12" fill="#0B2A4A">BJRC</text>
    </svg>
  );
};
